<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <ng-container *ngTemplateOutlet="btnTabs"></ng-container>
        </tt-card>

        <tt-list-legacy [listItems]="itemsListComponents" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>

        <tt-card>
            <tt-button-goto [ttText]="'components_add'" (ttClick)="goToFunc('component')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
        </tt-card>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="prod_id" [ttModel]="setting.prod_id" [ttButtons]="productIdButtons" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="setting.prod_name" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #btnTabs>
    <ng-container *ngIf="!!setting">
        <tt-tabs [(ttSelectedId)]="setting.gb_compfunction" (ttSelectedIdChange)="onTabChange()">
            <tt-tab ttId="EDIT" ttLabel="gb_compfunction_edit"></tt-tab>
            <tt-tab ttId="COMPONENTS" ttLabel="gb_compfunction_components"></tt-tab>
        </tt-tabs>
    </ng-container>
</ng-template>
